<!--
 * @Author: Junjie
 * @Date: 2022-11-19 14:51:59
 * @LastEditTime: 2022-11-21 11:15:00
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/report/online/modules/CommonCategoryTree.vue
-->
<template>
  <div class="tree-container">
    <div class="flex justify-between items-center pr-8px">
      <div class="top-text" v-if="!collapsed">{{ title || '报表类型' }}</div>
      <!-- <div class="top-icon">
        <a-icon :type="collapsed ? 'double-right' : 'double-left'" @click="toggle" class="trigger" />
      </div>-->
    </div>
    <div class="pr-8px" v-show="!collapsed">
      <a-directory-tree :block-node="true" :load-data="loadChildTreeNode" :treeData="treeData" @select="handleSelect" />
    </div>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage';

  export default {
    name: 'DocTypeTree',
    props: {
      value: {
        type: String,
        required: false
      },
      pCode: {
        type: String,
        required: false
      },
      title: {
        type: String,
        required: false
      },
      renderFilter: {
        type: String,
        required: false
      },
    },
    components: {

    },
    // 定义属性
    data () {
      return {
        name: 'CommonCategoryTree',
        pid: '',
        collapsed: false,
        treeValue: null,
        loadedKeys: [],
        expandedKeys: [],
        treeData: [],
        url: {
          rootList: "/custom/category/rootList",
          childList: "/custom/category/childList",
          getChildListBatch: "/custom/category/getChildListBatch",
        },
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.getParentRoot();
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      toggle () {
        this.collapsed = !this.collapsed
        this.$emit('update:collapsed', this.collapsed)
      },
      handleSelect (selectedKeys, event) {
        const value = selectedKeys[0];
        if (value === this.treeValue) {
          return;
        } else if (!value) {
          this.$emit('change', '');
          this.treeValue = null
        } else {
          this.$emit('change', event.node);
          this.treeValue = value
        }
      },
      getParentRoot () {
        getAction(this.url.childList, {
          code: this.pCode,
          enable: '1',
        }).then((res) => {
          if (res.success) {
            if (res.result.length == 0) {
              this.$message.warning('公共编码配置不正确，请联系管理员')
              return;
            } else {
              this.pid = res.result[0].id;
              this.loadRoot();
            }
          } else {
            this.$message.warning('公共编码配置不正确，请联系管理员')
          }
        });
      },
      loadRoot () {
        const params = {
          enable: '1',
          column: 'sortNo',
          order: 'asc'
        };
        if (this.pid) {
          params.pid = this.pid;
        }
        getAction(this.url.rootList, params).then((res) => {
          if (res.success) {
            if (res.result.records) {
              const nodes = this.getDataByResult(res.result.records);
              this.treeData = nodes;
            }
          } else {
            this.$message.warning(res.message)
          }
        });
      },
      loadChildTreeNode (treeNode) {
        return new Promise(resolve => {
          getAction(this.url.childList, {
            pid: treeNode.dataRef.id,
            enable: '1',
            column: 'sortNo',
            order: 'asc'
          }).then((res) => {
            if (res.success) {
              if (res.result.length == 0) {
                treeNode.dataRef['isLeaf'] = true
                return;
              } else {
                const nodes = this.getDataByResult(res.result);
                treeNode.dataRef['children'] = nodes;
                this.treeData = [...this.treeData];
              }
            } else {
              this.$message.warning(res.message)
            }
          });
          resolve();
        });
      },
      getDataByResult (result) {
        const renderFilter = this.renderFilter;
        if (result) {
          result = result.map(item => {
            if (renderFilter && !eval(renderFilter)) {
              return null;
            }
            item.key = item.id;
            item.title = item.name;
            item.isLeaf = !(item.hasChild === '1');
            return item
          });
          result = result.filter(item => item != null);
          return result;
        }
      },
    },
  }
</script>

<style lang='scss' scoped>

  .tree-container {
    transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  }
  .top-text {
    font-weight: 400;
    font-size: 14px;
    flex: 1;
    text-align: center;
  }
  .top-icon {
    line-height: 12px;
    padding: 6px 0px;
    .trigger {
      line-height: 14px;
      padding: 0 6px;
      font-size: 14px;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

</style>